/**
 * 假期解析（按公历+农历 fallback，无后端时使用）
 * 参考：shubing_pc ScheduleCalendarPage getFallbackHolidayName
 */

/**
 * 根据公历日期和农历字符串返回节日名称
 * @param {Date} date 本地日期
 * @param {string} [lunarDate] 农历字符串，如 "正月十五"
 * @returns {string|null} 节日名称或 null
 */
export function getHolidayName(date, lunarDate) {
  const month = date.getMonth() + 1
  const day = date.getDate()
  const solarKey = `${month}-${day}`
  const solarMap = {
    '1-1': '元旦',
    '5-1': '劳动节',
    '10-1': '国庆节',
  }
  if (solarMap[solarKey]) return solarMap[solarKey]
  if (!lunarDate) return null
  if (lunarDate.startsWith('正月初一')) return '春节'
  if (lunarDate.startsWith('正月初二') || lunarDate.startsWith('正月初三')) return '春节'
  if (lunarDate.startsWith('正月十五')) return '元宵'
  if (lunarDate.startsWith('五月初五')) return '端午'
  if (lunarDate.startsWith('八月十五')) return '中秋'
  if (lunarDate.startsWith('腊月初八')) return '腊八'
  if (lunarDate.startsWith('腊月廿三') || lunarDate.startsWith('腊月廿四')) return '小年'
  return null
}
